import React from 'react';
import { Box, Center, Divider, Group, Stack, Text } from '@mantine/core';
import Button from 'components/button/button';
import CommunityPageCard from './community_page_card';

const CommunityEventsCard = ({
  title,
  description,
  image_url,
  events = [],
}) => (
  <CommunityPageCard
    title={title}
    description={description}
    image_url={image_url}
  >
    {
      events.length === 0 ? (
        <Center mih={100}>
          <Text c='dimmed'>There are no upcoming events</Text>
        </Center>
      ) : (
        <Stack gap={0}>
          {
            events.map((event, index) => (
              <Box key={`${event.title}-${event.subtitle}`}>
                <Group justify='space-between' align='center' wrap='nowrap' py='xs'>
                  <Stack gap={0}>
                    <Text fw={700} size='sm'>{event.title}</Text>
                    <Text c='dimmed' size='sm'>{event.subtitle}</Text>
                  </Stack>
                  {
                    event.button_label && event.button_url &&
                      <Button
                        to={event.button_url}
                        background='transparent'
                        backgroundOnActive='transparent'
                        backgroundOnHover='transparent'
                        color='#1A1B1E'
                        fontSize='14px'
                        height='auto'
                        padding={0}
                        scaleOnActive={1}
                        style={{textDecoration: 'underline'}}
                      >
                        {event.button_label}
                      </Button>
                  }
                </Group>
                {index < events.length - 1 && <Divider />}
              </Box>
            ))
          }
        </Stack>
      )
    }
  </CommunityPageCard>
);

export default CommunityEventsCard;
